<template>
  <div class="dropdown-menu dropdown-menu-end">
    <a href="javascript:;" class="dropdown-item"
      ><span><i class="bx bx-x"></i></span>Close Chat
    </a>
    <a
      href="javascript:;"
      class="dropdown-item"
      data-bs-toggle="modal"
      data-bs-target="#mute-notification"
      ><span><i class="bx bx-volume-mute"></i></span>Mute Notification</a
    >
    <a
      href="javascript:;"
      class="dropdown-item"
      data-bs-toggle="modal"
      data-bs-target="#clear-chat"
      ><span><i class="bx bx-brush-alt"></i></span>Clear Message</a
    >
    <a
      href="javascript:;"
      class="dropdown-item"
      data-bs-toggle="modal"
      data-bs-target="#change-chat"
      ><span><i class="bx bx-trash-alt"></i></span>Delete Chat</a
    >
    <a
      href="javascript:;"
      class="dropdown-item"
      data-bs-toggle="modal"
      data-bs-target="#block-user"
      ><span><i class="bx bx-block"></i></span>Block</a
    >
  </div>
</template>
